"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboQuality = void 0;
function getComboQuality({ savingsPercentage, hasAdditionalCosts, comboEmptyDistanceCoefficient, }) {
    // Soft-disable marking combo as best quality until combos in CT are enabled
    if (savingsPercentage >= 45 && comboEmptyDistanceCoefficient < 0.03 && !hasAdditionalCosts) {
        return "best";
    }
    if (savingsPercentage >= 20) {
        return "mediocre";
    }
    return "worst";
}
exports.getComboQuality = getComboQuality;
//# sourceMappingURL=getComboQuality.js.map